module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/football-df67e288f28fab93cd986bfd0680d4fb.svg";